import { useState } from "react";
import { Globe, Check } from "lucide-react";
import { useI18n, LANGS } from "@/lib/i18n";

export default function LangSwitcher({ className = "" }) {
  const { lang, setLang } = useI18n();
  const [open, setOpen] = useState(false);
  const current = LANGS.find((l) => l.code === lang) || LANGS[0];

  return (
    <div className={`relative ${className}`}>
      <button
        data-testid="lang-switcher-btn"
        onClick={() => setOpen((o) => !o)}
        className="inline-flex h-9 items-center gap-2 rounded-sm border border-border/60 bg-card/40 px-2.5 text-sm hover:bg-card transition-colors"
      >
        <Globe className="h-4 w-4" />
        <span className="font-medium">{current.short}</span>
      </button>
      {open && (
        <>
          <div className="fixed inset-0 z-40" onClick={() => setOpen(false)} />
          <div className="absolute end-0 mt-2 w-44 rounded-sm border border-border bg-popover/95 backdrop-blur-xl p-1 shadow-xl z-50">
            {LANGS.map((l) => (
              <button
                key={l.code}
                data-testid={`lang-option-${l.code}`}
                onClick={() => {
                  setLang(l.code);
                  setOpen(false);
                }}
                className="flex w-full items-center justify-between gap-2 rounded-sm px-2.5 py-2 text-sm hover:bg-accent text-foreground"
              >
                <span>{l.label}</span>
                {lang === l.code && <Check className="h-3.5 w-3.5" />}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
